import { useEffect } from 'react';
import { useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function useAnimations(props) {
  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  const animationControl = useAnimation();

  const animationProps = {
    initial: 'from',
    animate: animationControl,
    variants: {
      from: {},
      to: {},
    },
  };

  if (props.fadeIn) {
    animationProps.variants.from = {
      ...animationProps.variants.from,
      opacity: 0,
      transition: {
        duration: props.fadeInDuration,
      },
    };
    animationProps.variants.to = {
      ...animationProps.variants.to,
      opacity: 1,
      transition: {
        duration: props.fadeInDuration,
      },
    };
  }

  if (props.slide) {
    animationProps.variants.from = {
      ...animationProps.variants.from,
      x: props.slideFrom === 'right' ? '50%' : '-50%',
      transition: {
        duration: Number(props.slideDuration),
      },
    };
    animationProps.variants.to = {
      ...animationProps.variants.to,
      x: 0,
      transition: {
        duration: Number(props.slideDuration),
      },
    };
  }

  if (props.zoomIn) {
    animationProps.variants.from = {
      ...animationProps.variants.from,
      scale: 1,
      transition: {
        duration: 2,
      },
    };
    animationProps.variants.to = {
      ...animationProps.variants.to,
      scale: Number(props.zoomInScale),
      transition: {
        duration: 2,
      },
    };
  }

  if (props.zoomOut) {
    animationProps.variants.from = {
      ...animationProps.variants.from,
      scale: Number(props.zoomOutScale),
      transition: {
        duration: 2,
      },
    };
    animationProps.variants.to = {
      ...animationProps.variants.to,
      scale: 1,
      transition: {
        duration: 2,
      },
    };
  }

  useEffect(() => {
    if (
      !props.fadeIn && 
      !props.slide && 
      !props.zoomIn &&
      !props.zoomOut
    ) {
      return;
    }
    animationControl.start(inView ? 'to' : 'from');
  }, [animationControl, inView]);

  return {
    ref,
    animationProps,
  };
}

export default useAnimations;
